import { gql } from '@apollo/client';
import { ID_NAME_FIELDS } from 'graphql/common/fragments';

export const ASSET_PERFORMANCE_FRAGMENT = gql`
  fragment assetPerformanceData on AssetPerformance {
    id
    createdAt
    updatedAt
    propertyId
    date
    vacantSfDirect
    vacantSfSublet
    vacantSfShell
    vacantKwTurnkey
    availableSfDirect
    availableSfSublet
    availableSfShell
    availableKwTurnkey
    notes
  }
`;

export const MARKET_PRICING_FRAGMENT = gql`
  fragment marketingPricingData on MarketPricing {
    id
    createdAt
    updatedAt
    year
    market {
      ${ID_NAME_FIELDS}
    }
    submarket {
      ${ID_NAME_FIELDS}
    }
    propertyType {
      ${ID_NAME_FIELDS}
    }
    propertyClass {
      ${ID_NAME_FIELDS}
    }
    propertySubtype {
      ${ID_NAME_FIELDS}
    }
    directRent
    darPercent
    tiLongTerm
    tiPercent
    freeRentLongTerm
    rentType
    timeMeasurement
  }
`;
